<script>
export default {
    props: {
        value: {
            type: String,
            required: true,
        },
        searchPhrase: {
            type: String,
            required: true,
            example: 'Ips',
        },
    },
    methods: {
        createElements(createElement) {
            const queryWords = this.searchPhrase
                .trim()
                .split(' ')
                .filter((word) => word !== '')
                .map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
                .sort((a, b) => b.length - a.length || a.localeCompare(b));

            let parts = [this.value];
            queryWords.forEach((queryWord) => parts = this.highlight(parts, queryWord, createElement));

            return parts;
        },
        highlight(parts, queryWord, createElement) {
            const regExp = new RegExp(`(${queryWord})`, 'gi');

            const results = [];
            parts.forEach((part) => {
                if (typeof part !== 'string') {
                    // already a span / highlighted
                    results.push(part);
                } else {
                    part.split(regExp)
                        .forEach((part) => {
                            if (part.search(regExp) >= 0) {
                                results.push(createElement('span', { class: 'highlight' }, part));
                            } else {
                                results.push(part);
                            }
                        });
                }
            });

            return results;
        },
    },
    render(createElement) {
        return createElement('span', this.createElements(createElement));
    },
};
</script>

<style scoped rel="stylesheet/scss" lang="scss">
    .highlight {
    background-color: rgba(19, 132, 193, 0.29);
}
</style>
